"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Jellyfin API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SyncPlayApi = exports.SyncPlayApiFactory = exports.SyncPlayApiFp = exports.SyncPlayApiAxiosParamCreator = void 0;
var axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
var base_1 = require("../base");
/**
 * SyncPlayApi - axios parameter creator
 * @export
 */
exports.SyncPlayApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Notify SyncPlay group that member is buffering.
         * @param {BufferRequestDto} bufferRequestDto The player status.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncPlayBuffering: function (bufferRequestDto, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, queryParameters, key, key, headersFromBaseOptions, nonString, needsSerialization;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'bufferRequestDto' is not null or undefined
                            if (bufferRequestDto === null || bufferRequestDto === undefined) {
                                throw new base_1.RequiredError('bufferRequestDto', 'Required parameter bufferRequestDto was null or undefined when calling syncPlayBuffering.');
                            }
                            localVarPath = "/SyncPlay/Buffering";
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("X-Emby-Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["X-Emby-Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            queryParameters = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                queryParameters.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                queryParameters.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            nonString = typeof bufferRequestDto !== 'string';
                            needsSerialization = nonString && configuration && configuration.isJsonMime
                                ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
                                : nonString;
                            localVarRequestOptions.data = needsSerialization
                                ? JSON.stringify(bufferRequestDto !== undefined ? bufferRequestDto : {})
                                : (bufferRequestDto || "");
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Create a new SyncPlay group.
         * @param {NewGroupRequestDto} newGroupRequestDto The settings of the new group.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncPlayCreateGroup: function (newGroupRequestDto, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, queryParameters, key, key, headersFromBaseOptions, nonString, needsSerialization;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'newGroupRequestDto' is not null or undefined
                            if (newGroupRequestDto === null || newGroupRequestDto === undefined) {
                                throw new base_1.RequiredError('newGroupRequestDto', 'Required parameter newGroupRequestDto was null or undefined when calling syncPlayCreateGroup.');
                            }
                            localVarPath = "/SyncPlay/New";
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("X-Emby-Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["X-Emby-Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            queryParameters = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                queryParameters.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                queryParameters.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            nonString = typeof newGroupRequestDto !== 'string';
                            needsSerialization = nonString && configuration && configuration.isJsonMime
                                ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
                                : nonString;
                            localVarRequestOptions.data = needsSerialization
                                ? JSON.stringify(newGroupRequestDto !== undefined ? newGroupRequestDto : {})
                                : (newGroupRequestDto || "");
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Gets all SyncPlay groups.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncPlayGetGroups: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, queryParameters, key, key, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            localVarPath = "/SyncPlay/List";
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("X-Emby-Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["X-Emby-Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            queryParameters = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                queryParameters.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                queryParameters.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Join an existing SyncPlay group.
         * @param {JoinGroupRequestDto} joinGroupRequestDto The group to join.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncPlayJoinGroup: function (joinGroupRequestDto, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, queryParameters, key, key, headersFromBaseOptions, nonString, needsSerialization;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'joinGroupRequestDto' is not null or undefined
                            if (joinGroupRequestDto === null || joinGroupRequestDto === undefined) {
                                throw new base_1.RequiredError('joinGroupRequestDto', 'Required parameter joinGroupRequestDto was null or undefined when calling syncPlayJoinGroup.');
                            }
                            localVarPath = "/SyncPlay/Join";
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("X-Emby-Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["X-Emby-Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            queryParameters = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                queryParameters.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                queryParameters.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            nonString = typeof joinGroupRequestDto !== 'string';
                            needsSerialization = nonString && configuration && configuration.isJsonMime
                                ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
                                : nonString;
                            localVarRequestOptions.data = needsSerialization
                                ? JSON.stringify(joinGroupRequestDto !== undefined ? joinGroupRequestDto : {})
                                : (joinGroupRequestDto || "");
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Leave the joined SyncPlay group.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncPlayLeaveGroup: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, queryParameters, key, key, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            localVarPath = "/SyncPlay/Leave";
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("X-Emby-Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["X-Emby-Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            queryParameters = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                queryParameters.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                queryParameters.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Request to move an item in the playlist in SyncPlay group.
         * @param {MovePlaylistItemRequestDto} movePlaylistItemRequestDto The new position for the item.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncPlayMovePlaylistItem: function (movePlaylistItemRequestDto, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, queryParameters, key, key, headersFromBaseOptions, nonString, needsSerialization;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'movePlaylistItemRequestDto' is not null or undefined
                            if (movePlaylistItemRequestDto === null || movePlaylistItemRequestDto === undefined) {
                                throw new base_1.RequiredError('movePlaylistItemRequestDto', 'Required parameter movePlaylistItemRequestDto was null or undefined when calling syncPlayMovePlaylistItem.');
                            }
                            localVarPath = "/SyncPlay/MovePlaylistItem";
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("X-Emby-Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["X-Emby-Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            queryParameters = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                queryParameters.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                queryParameters.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            nonString = typeof movePlaylistItemRequestDto !== 'string';
                            needsSerialization = nonString && configuration && configuration.isJsonMime
                                ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
                                : nonString;
                            localVarRequestOptions.data = needsSerialization
                                ? JSON.stringify(movePlaylistItemRequestDto !== undefined ? movePlaylistItemRequestDto : {})
                                : (movePlaylistItemRequestDto || "");
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Request next item in SyncPlay group.
         * @param {NextItemRequestDto} nextItemRequestDto The current item information.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncPlayNextItem: function (nextItemRequestDto, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, queryParameters, key, key, headersFromBaseOptions, nonString, needsSerialization;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'nextItemRequestDto' is not null or undefined
                            if (nextItemRequestDto === null || nextItemRequestDto === undefined) {
                                throw new base_1.RequiredError('nextItemRequestDto', 'Required parameter nextItemRequestDto was null or undefined when calling syncPlayNextItem.');
                            }
                            localVarPath = "/SyncPlay/NextItem";
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("X-Emby-Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["X-Emby-Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            queryParameters = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                queryParameters.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                queryParameters.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            nonString = typeof nextItemRequestDto !== 'string';
                            needsSerialization = nonString && configuration && configuration.isJsonMime
                                ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
                                : nonString;
                            localVarRequestOptions.data = needsSerialization
                                ? JSON.stringify(nextItemRequestDto !== undefined ? nextItemRequestDto : {})
                                : (nextItemRequestDto || "");
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Request pause in SyncPlay group.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncPlayPause: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, queryParameters, key, key, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            localVarPath = "/SyncPlay/Pause";
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("X-Emby-Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["X-Emby-Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            queryParameters = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                queryParameters.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                queryParameters.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update session ping.
         * @param {PingRequestDto} pingRequestDto The new ping.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncPlayPing: function (pingRequestDto, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, queryParameters, key, key, headersFromBaseOptions, nonString, needsSerialization;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'pingRequestDto' is not null or undefined
                            if (pingRequestDto === null || pingRequestDto === undefined) {
                                throw new base_1.RequiredError('pingRequestDto', 'Required parameter pingRequestDto was null or undefined when calling syncPlayPing.');
                            }
                            localVarPath = "/SyncPlay/Ping";
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("X-Emby-Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["X-Emby-Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            queryParameters = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                queryParameters.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                queryParameters.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            nonString = typeof pingRequestDto !== 'string';
                            needsSerialization = nonString && configuration && configuration.isJsonMime
                                ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
                                : nonString;
                            localVarRequestOptions.data = needsSerialization
                                ? JSON.stringify(pingRequestDto !== undefined ? pingRequestDto : {})
                                : (pingRequestDto || "");
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Request previous item in SyncPlay group.
         * @param {PreviousItemRequestDto} previousItemRequestDto The current item information.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncPlayPreviousItem: function (previousItemRequestDto, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, queryParameters, key, key, headersFromBaseOptions, nonString, needsSerialization;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'previousItemRequestDto' is not null or undefined
                            if (previousItemRequestDto === null || previousItemRequestDto === undefined) {
                                throw new base_1.RequiredError('previousItemRequestDto', 'Required parameter previousItemRequestDto was null or undefined when calling syncPlayPreviousItem.');
                            }
                            localVarPath = "/SyncPlay/PreviousItem";
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("X-Emby-Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["X-Emby-Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            queryParameters = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                queryParameters.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                queryParameters.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            nonString = typeof previousItemRequestDto !== 'string';
                            needsSerialization = nonString && configuration && configuration.isJsonMime
                                ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
                                : nonString;
                            localVarRequestOptions.data = needsSerialization
                                ? JSON.stringify(previousItemRequestDto !== undefined ? previousItemRequestDto : {})
                                : (previousItemRequestDto || "");
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Request to queue items to the playlist of a SyncPlay group.
         * @param {QueueRequestDto} queueRequestDto The items to add.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncPlayQueue: function (queueRequestDto, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, queryParameters, key, key, headersFromBaseOptions, nonString, needsSerialization;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'queueRequestDto' is not null or undefined
                            if (queueRequestDto === null || queueRequestDto === undefined) {
                                throw new base_1.RequiredError('queueRequestDto', 'Required parameter queueRequestDto was null or undefined when calling syncPlayQueue.');
                            }
                            localVarPath = "/SyncPlay/Queue";
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("X-Emby-Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["X-Emby-Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            queryParameters = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                queryParameters.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                queryParameters.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            nonString = typeof queueRequestDto !== 'string';
                            needsSerialization = nonString && configuration && configuration.isJsonMime
                                ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
                                : nonString;
                            localVarRequestOptions.data = needsSerialization
                                ? JSON.stringify(queueRequestDto !== undefined ? queueRequestDto : {})
                                : (queueRequestDto || "");
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Notify SyncPlay group that member is ready for playback.
         * @param {ReadyRequestDto} readyRequestDto The player status.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncPlayReady: function (readyRequestDto, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, queryParameters, key, key, headersFromBaseOptions, nonString, needsSerialization;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'readyRequestDto' is not null or undefined
                            if (readyRequestDto === null || readyRequestDto === undefined) {
                                throw new base_1.RequiredError('readyRequestDto', 'Required parameter readyRequestDto was null or undefined when calling syncPlayReady.');
                            }
                            localVarPath = "/SyncPlay/Ready";
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("X-Emby-Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["X-Emby-Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            queryParameters = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                queryParameters.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                queryParameters.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            nonString = typeof readyRequestDto !== 'string';
                            needsSerialization = nonString && configuration && configuration.isJsonMime
                                ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
                                : nonString;
                            localVarRequestOptions.data = needsSerialization
                                ? JSON.stringify(readyRequestDto !== undefined ? readyRequestDto : {})
                                : (readyRequestDto || "");
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Request to remove items from the playlist in SyncPlay group.
         * @param {RemoveFromPlaylistRequestDto} removeFromPlaylistRequestDto The items to remove.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncPlayRemoveFromPlaylist: function (removeFromPlaylistRequestDto, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, queryParameters, key, key, headersFromBaseOptions, nonString, needsSerialization;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'removeFromPlaylistRequestDto' is not null or undefined
                            if (removeFromPlaylistRequestDto === null || removeFromPlaylistRequestDto === undefined) {
                                throw new base_1.RequiredError('removeFromPlaylistRequestDto', 'Required parameter removeFromPlaylistRequestDto was null or undefined when calling syncPlayRemoveFromPlaylist.');
                            }
                            localVarPath = "/SyncPlay/RemoveFromPlaylist";
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("X-Emby-Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["X-Emby-Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            queryParameters = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                queryParameters.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                queryParameters.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            nonString = typeof removeFromPlaylistRequestDto !== 'string';
                            needsSerialization = nonString && configuration && configuration.isJsonMime
                                ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
                                : nonString;
                            localVarRequestOptions.data = needsSerialization
                                ? JSON.stringify(removeFromPlaylistRequestDto !== undefined ? removeFromPlaylistRequestDto : {})
                                : (removeFromPlaylistRequestDto || "");
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Request seek in SyncPlay group.
         * @param {SeekRequestDto} seekRequestDto The new playback position.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncPlaySeek: function (seekRequestDto, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, queryParameters, key, key, headersFromBaseOptions, nonString, needsSerialization;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'seekRequestDto' is not null or undefined
                            if (seekRequestDto === null || seekRequestDto === undefined) {
                                throw new base_1.RequiredError('seekRequestDto', 'Required parameter seekRequestDto was null or undefined when calling syncPlaySeek.');
                            }
                            localVarPath = "/SyncPlay/Seek";
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("X-Emby-Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["X-Emby-Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            queryParameters = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                queryParameters.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                queryParameters.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            nonString = typeof seekRequestDto !== 'string';
                            needsSerialization = nonString && configuration && configuration.isJsonMime
                                ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
                                : nonString;
                            localVarRequestOptions.data = needsSerialization
                                ? JSON.stringify(seekRequestDto !== undefined ? seekRequestDto : {})
                                : (seekRequestDto || "");
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Request SyncPlay group to ignore member during group-wait.
         * @param {IgnoreWaitRequestDto} ignoreWaitRequestDto The settings to set.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncPlaySetIgnoreWait: function (ignoreWaitRequestDto, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, queryParameters, key, key, headersFromBaseOptions, nonString, needsSerialization;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'ignoreWaitRequestDto' is not null or undefined
                            if (ignoreWaitRequestDto === null || ignoreWaitRequestDto === undefined) {
                                throw new base_1.RequiredError('ignoreWaitRequestDto', 'Required parameter ignoreWaitRequestDto was null or undefined when calling syncPlaySetIgnoreWait.');
                            }
                            localVarPath = "/SyncPlay/SetIgnoreWait";
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("X-Emby-Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["X-Emby-Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            queryParameters = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                queryParameters.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                queryParameters.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            nonString = typeof ignoreWaitRequestDto !== 'string';
                            needsSerialization = nonString && configuration && configuration.isJsonMime
                                ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
                                : nonString;
                            localVarRequestOptions.data = needsSerialization
                                ? JSON.stringify(ignoreWaitRequestDto !== undefined ? ignoreWaitRequestDto : {})
                                : (ignoreWaitRequestDto || "");
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Request to set new playlist in SyncPlay group.
         * @param {PlayRequestDto} playRequestDto The new playlist to play in the group.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncPlaySetNewQueue: function (playRequestDto, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, queryParameters, key, key, headersFromBaseOptions, nonString, needsSerialization;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'playRequestDto' is not null or undefined
                            if (playRequestDto === null || playRequestDto === undefined) {
                                throw new base_1.RequiredError('playRequestDto', 'Required parameter playRequestDto was null or undefined when calling syncPlaySetNewQueue.');
                            }
                            localVarPath = "/SyncPlay/SetNewQueue";
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("X-Emby-Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["X-Emby-Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            queryParameters = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                queryParameters.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                queryParameters.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            nonString = typeof playRequestDto !== 'string';
                            needsSerialization = nonString && configuration && configuration.isJsonMime
                                ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
                                : nonString;
                            localVarRequestOptions.data = needsSerialization
                                ? JSON.stringify(playRequestDto !== undefined ? playRequestDto : {})
                                : (playRequestDto || "");
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Request to change playlist item in SyncPlay group.
         * @param {SetPlaylistItemRequestDto} setPlaylistItemRequestDto The new item to play.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncPlaySetPlaylistItem: function (setPlaylistItemRequestDto, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, queryParameters, key, key, headersFromBaseOptions, nonString, needsSerialization;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'setPlaylistItemRequestDto' is not null or undefined
                            if (setPlaylistItemRequestDto === null || setPlaylistItemRequestDto === undefined) {
                                throw new base_1.RequiredError('setPlaylistItemRequestDto', 'Required parameter setPlaylistItemRequestDto was null or undefined when calling syncPlaySetPlaylistItem.');
                            }
                            localVarPath = "/SyncPlay/SetPlaylistItem";
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("X-Emby-Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["X-Emby-Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            queryParameters = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                queryParameters.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                queryParameters.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            nonString = typeof setPlaylistItemRequestDto !== 'string';
                            needsSerialization = nonString && configuration && configuration.isJsonMime
                                ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
                                : nonString;
                            localVarRequestOptions.data = needsSerialization
                                ? JSON.stringify(setPlaylistItemRequestDto !== undefined ? setPlaylistItemRequestDto : {})
                                : (setPlaylistItemRequestDto || "");
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Request to set repeat mode in SyncPlay group.
         * @param {SetRepeatModeRequestDto} setRepeatModeRequestDto The new repeat mode.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncPlaySetRepeatMode: function (setRepeatModeRequestDto, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, queryParameters, key, key, headersFromBaseOptions, nonString, needsSerialization;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'setRepeatModeRequestDto' is not null or undefined
                            if (setRepeatModeRequestDto === null || setRepeatModeRequestDto === undefined) {
                                throw new base_1.RequiredError('setRepeatModeRequestDto', 'Required parameter setRepeatModeRequestDto was null or undefined when calling syncPlaySetRepeatMode.');
                            }
                            localVarPath = "/SyncPlay/SetRepeatMode";
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("X-Emby-Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["X-Emby-Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            queryParameters = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                queryParameters.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                queryParameters.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            nonString = typeof setRepeatModeRequestDto !== 'string';
                            needsSerialization = nonString && configuration && configuration.isJsonMime
                                ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
                                : nonString;
                            localVarRequestOptions.data = needsSerialization
                                ? JSON.stringify(setRepeatModeRequestDto !== undefined ? setRepeatModeRequestDto : {})
                                : (setRepeatModeRequestDto || "");
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Request to set shuffle mode in SyncPlay group.
         * @param {SetShuffleModeRequestDto} setShuffleModeRequestDto The new shuffle mode.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncPlaySetShuffleMode: function (setShuffleModeRequestDto, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, queryParameters, key, key, headersFromBaseOptions, nonString, needsSerialization;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'setShuffleModeRequestDto' is not null or undefined
                            if (setShuffleModeRequestDto === null || setShuffleModeRequestDto === undefined) {
                                throw new base_1.RequiredError('setShuffleModeRequestDto', 'Required parameter setShuffleModeRequestDto was null or undefined when calling syncPlaySetShuffleMode.');
                            }
                            localVarPath = "/SyncPlay/SetShuffleMode";
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("X-Emby-Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["X-Emby-Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            queryParameters = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                queryParameters.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                queryParameters.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            nonString = typeof setShuffleModeRequestDto !== 'string';
                            needsSerialization = nonString && configuration && configuration.isJsonMime
                                ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
                                : nonString;
                            localVarRequestOptions.data = needsSerialization
                                ? JSON.stringify(setShuffleModeRequestDto !== undefined ? setShuffleModeRequestDto : {})
                                : (setShuffleModeRequestDto || "");
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Request stop in SyncPlay group.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncPlayStop: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, queryParameters, key, key, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            localVarPath = "/SyncPlay/Stop";
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("X-Emby-Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["X-Emby-Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            queryParameters = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                queryParameters.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                queryParameters.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Request unpause in SyncPlay group.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncPlayUnpause: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, queryParameters, key, key, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            localVarPath = "/SyncPlay/Unpause";
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("X-Emby-Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["X-Emby-Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            queryParameters = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                queryParameters.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                queryParameters.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
/**
 * SyncPlayApi - functional programming interface
 * @export
 */
exports.SyncPlayApiFp = function (configuration) {
    return {
        /**
         *
         * @summary Notify SyncPlay group that member is buffering.
         * @param {BufferRequestDto} bufferRequestDto The player status.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncPlayBuffering: function (bufferRequestDto, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.SyncPlayApiAxiosParamCreator(configuration).syncPlayBuffering(bufferRequestDto, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Create a new SyncPlay group.
         * @param {NewGroupRequestDto} newGroupRequestDto The settings of the new group.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncPlayCreateGroup: function (newGroupRequestDto, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.SyncPlayApiAxiosParamCreator(configuration).syncPlayCreateGroup(newGroupRequestDto, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Gets all SyncPlay groups.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncPlayGetGroups: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.SyncPlayApiAxiosParamCreator(configuration).syncPlayGetGroups(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Join an existing SyncPlay group.
         * @param {JoinGroupRequestDto} joinGroupRequestDto The group to join.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncPlayJoinGroup: function (joinGroupRequestDto, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.SyncPlayApiAxiosParamCreator(configuration).syncPlayJoinGroup(joinGroupRequestDto, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Leave the joined SyncPlay group.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncPlayLeaveGroup: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.SyncPlayApiAxiosParamCreator(configuration).syncPlayLeaveGroup(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Request to move an item in the playlist in SyncPlay group.
         * @param {MovePlaylistItemRequestDto} movePlaylistItemRequestDto The new position for the item.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncPlayMovePlaylistItem: function (movePlaylistItemRequestDto, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.SyncPlayApiAxiosParamCreator(configuration).syncPlayMovePlaylistItem(movePlaylistItemRequestDto, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Request next item in SyncPlay group.
         * @param {NextItemRequestDto} nextItemRequestDto The current item information.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncPlayNextItem: function (nextItemRequestDto, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.SyncPlayApiAxiosParamCreator(configuration).syncPlayNextItem(nextItemRequestDto, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Request pause in SyncPlay group.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncPlayPause: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.SyncPlayApiAxiosParamCreator(configuration).syncPlayPause(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update session ping.
         * @param {PingRequestDto} pingRequestDto The new ping.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncPlayPing: function (pingRequestDto, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.SyncPlayApiAxiosParamCreator(configuration).syncPlayPing(pingRequestDto, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Request previous item in SyncPlay group.
         * @param {PreviousItemRequestDto} previousItemRequestDto The current item information.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncPlayPreviousItem: function (previousItemRequestDto, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.SyncPlayApiAxiosParamCreator(configuration).syncPlayPreviousItem(previousItemRequestDto, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Request to queue items to the playlist of a SyncPlay group.
         * @param {QueueRequestDto} queueRequestDto The items to add.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncPlayQueue: function (queueRequestDto, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.SyncPlayApiAxiosParamCreator(configuration).syncPlayQueue(queueRequestDto, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Notify SyncPlay group that member is ready for playback.
         * @param {ReadyRequestDto} readyRequestDto The player status.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncPlayReady: function (readyRequestDto, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.SyncPlayApiAxiosParamCreator(configuration).syncPlayReady(readyRequestDto, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Request to remove items from the playlist in SyncPlay group.
         * @param {RemoveFromPlaylistRequestDto} removeFromPlaylistRequestDto The items to remove.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncPlayRemoveFromPlaylist: function (removeFromPlaylistRequestDto, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.SyncPlayApiAxiosParamCreator(configuration).syncPlayRemoveFromPlaylist(removeFromPlaylistRequestDto, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Request seek in SyncPlay group.
         * @param {SeekRequestDto} seekRequestDto The new playback position.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncPlaySeek: function (seekRequestDto, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.SyncPlayApiAxiosParamCreator(configuration).syncPlaySeek(seekRequestDto, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Request SyncPlay group to ignore member during group-wait.
         * @param {IgnoreWaitRequestDto} ignoreWaitRequestDto The settings to set.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncPlaySetIgnoreWait: function (ignoreWaitRequestDto, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.SyncPlayApiAxiosParamCreator(configuration).syncPlaySetIgnoreWait(ignoreWaitRequestDto, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Request to set new playlist in SyncPlay group.
         * @param {PlayRequestDto} playRequestDto The new playlist to play in the group.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncPlaySetNewQueue: function (playRequestDto, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.SyncPlayApiAxiosParamCreator(configuration).syncPlaySetNewQueue(playRequestDto, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Request to change playlist item in SyncPlay group.
         * @param {SetPlaylistItemRequestDto} setPlaylistItemRequestDto The new item to play.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncPlaySetPlaylistItem: function (setPlaylistItemRequestDto, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.SyncPlayApiAxiosParamCreator(configuration).syncPlaySetPlaylistItem(setPlaylistItemRequestDto, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Request to set repeat mode in SyncPlay group.
         * @param {SetRepeatModeRequestDto} setRepeatModeRequestDto The new repeat mode.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncPlaySetRepeatMode: function (setRepeatModeRequestDto, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.SyncPlayApiAxiosParamCreator(configuration).syncPlaySetRepeatMode(setRepeatModeRequestDto, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Request to set shuffle mode in SyncPlay group.
         * @param {SetShuffleModeRequestDto} setShuffleModeRequestDto The new shuffle mode.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncPlaySetShuffleMode: function (setShuffleModeRequestDto, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.SyncPlayApiAxiosParamCreator(configuration).syncPlaySetShuffleMode(setShuffleModeRequestDto, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Request stop in SyncPlay group.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncPlayStop: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.SyncPlayApiAxiosParamCreator(configuration).syncPlayStop(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Request unpause in SyncPlay group.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncPlayUnpause: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.SyncPlayApiAxiosParamCreator(configuration).syncPlayUnpause(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
    };
};
/**
 * SyncPlayApi - factory interface
 * @export
 */
exports.SyncPlayApiFactory = function (configuration, basePath, axios) {
    return {
        /**
         *
         * @summary Notify SyncPlay group that member is buffering.
         * @param {BufferRequestDto} bufferRequestDto The player status.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncPlayBuffering: function (bufferRequestDto, options) {
            return exports.SyncPlayApiFp(configuration).syncPlayBuffering(bufferRequestDto, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Create a new SyncPlay group.
         * @param {NewGroupRequestDto} newGroupRequestDto The settings of the new group.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncPlayCreateGroup: function (newGroupRequestDto, options) {
            return exports.SyncPlayApiFp(configuration).syncPlayCreateGroup(newGroupRequestDto, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Gets all SyncPlay groups.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncPlayGetGroups: function (options) {
            return exports.SyncPlayApiFp(configuration).syncPlayGetGroups(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Join an existing SyncPlay group.
         * @param {JoinGroupRequestDto} joinGroupRequestDto The group to join.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncPlayJoinGroup: function (joinGroupRequestDto, options) {
            return exports.SyncPlayApiFp(configuration).syncPlayJoinGroup(joinGroupRequestDto, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Leave the joined SyncPlay group.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncPlayLeaveGroup: function (options) {
            return exports.SyncPlayApiFp(configuration).syncPlayLeaveGroup(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Request to move an item in the playlist in SyncPlay group.
         * @param {MovePlaylistItemRequestDto} movePlaylistItemRequestDto The new position for the item.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncPlayMovePlaylistItem: function (movePlaylistItemRequestDto, options) {
            return exports.SyncPlayApiFp(configuration).syncPlayMovePlaylistItem(movePlaylistItemRequestDto, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Request next item in SyncPlay group.
         * @param {NextItemRequestDto} nextItemRequestDto The current item information.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncPlayNextItem: function (nextItemRequestDto, options) {
            return exports.SyncPlayApiFp(configuration).syncPlayNextItem(nextItemRequestDto, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Request pause in SyncPlay group.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncPlayPause: function (options) {
            return exports.SyncPlayApiFp(configuration).syncPlayPause(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update session ping.
         * @param {PingRequestDto} pingRequestDto The new ping.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncPlayPing: function (pingRequestDto, options) {
            return exports.SyncPlayApiFp(configuration).syncPlayPing(pingRequestDto, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Request previous item in SyncPlay group.
         * @param {PreviousItemRequestDto} previousItemRequestDto The current item information.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncPlayPreviousItem: function (previousItemRequestDto, options) {
            return exports.SyncPlayApiFp(configuration).syncPlayPreviousItem(previousItemRequestDto, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Request to queue items to the playlist of a SyncPlay group.
         * @param {QueueRequestDto} queueRequestDto The items to add.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncPlayQueue: function (queueRequestDto, options) {
            return exports.SyncPlayApiFp(configuration).syncPlayQueue(queueRequestDto, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Notify SyncPlay group that member is ready for playback.
         * @param {ReadyRequestDto} readyRequestDto The player status.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncPlayReady: function (readyRequestDto, options) {
            return exports.SyncPlayApiFp(configuration).syncPlayReady(readyRequestDto, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Request to remove items from the playlist in SyncPlay group.
         * @param {RemoveFromPlaylistRequestDto} removeFromPlaylistRequestDto The items to remove.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncPlayRemoveFromPlaylist: function (removeFromPlaylistRequestDto, options) {
            return exports.SyncPlayApiFp(configuration).syncPlayRemoveFromPlaylist(removeFromPlaylistRequestDto, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Request seek in SyncPlay group.
         * @param {SeekRequestDto} seekRequestDto The new playback position.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncPlaySeek: function (seekRequestDto, options) {
            return exports.SyncPlayApiFp(configuration).syncPlaySeek(seekRequestDto, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Request SyncPlay group to ignore member during group-wait.
         * @param {IgnoreWaitRequestDto} ignoreWaitRequestDto The settings to set.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncPlaySetIgnoreWait: function (ignoreWaitRequestDto, options) {
            return exports.SyncPlayApiFp(configuration).syncPlaySetIgnoreWait(ignoreWaitRequestDto, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Request to set new playlist in SyncPlay group.
         * @param {PlayRequestDto} playRequestDto The new playlist to play in the group.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncPlaySetNewQueue: function (playRequestDto, options) {
            return exports.SyncPlayApiFp(configuration).syncPlaySetNewQueue(playRequestDto, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Request to change playlist item in SyncPlay group.
         * @param {SetPlaylistItemRequestDto} setPlaylistItemRequestDto The new item to play.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncPlaySetPlaylistItem: function (setPlaylistItemRequestDto, options) {
            return exports.SyncPlayApiFp(configuration).syncPlaySetPlaylistItem(setPlaylistItemRequestDto, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Request to set repeat mode in SyncPlay group.
         * @param {SetRepeatModeRequestDto} setRepeatModeRequestDto The new repeat mode.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncPlaySetRepeatMode: function (setRepeatModeRequestDto, options) {
            return exports.SyncPlayApiFp(configuration).syncPlaySetRepeatMode(setRepeatModeRequestDto, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Request to set shuffle mode in SyncPlay group.
         * @param {SetShuffleModeRequestDto} setShuffleModeRequestDto The new shuffle mode.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncPlaySetShuffleMode: function (setShuffleModeRequestDto, options) {
            return exports.SyncPlayApiFp(configuration).syncPlaySetShuffleMode(setShuffleModeRequestDto, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Request stop in SyncPlay group.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncPlayStop: function (options) {
            return exports.SyncPlayApiFp(configuration).syncPlayStop(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Request unpause in SyncPlay group.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncPlayUnpause: function (options) {
            return exports.SyncPlayApiFp(configuration).syncPlayUnpause(options).then(function (request) { return request(axios, basePath); });
        },
    };
};
/**
 * SyncPlayApi - object-oriented interface
 * @export
 * @class SyncPlayApi
 * @extends {BaseAPI}
 */
var SyncPlayApi = /** @class */ (function (_super) {
    __extends(SyncPlayApi, _super);
    function SyncPlayApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Notify SyncPlay group that member is buffering.
     * @param {SyncPlayApiSyncPlayBufferingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SyncPlayApi
     */
    SyncPlayApi.prototype.syncPlayBuffering = function (requestParameters, options) {
        var _this = this;
        return exports.SyncPlayApiFp(this.configuration).syncPlayBuffering(requestParameters.bufferRequestDto, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Create a new SyncPlay group.
     * @param {SyncPlayApiSyncPlayCreateGroupRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SyncPlayApi
     */
    SyncPlayApi.prototype.syncPlayCreateGroup = function (requestParameters, options) {
        var _this = this;
        return exports.SyncPlayApiFp(this.configuration).syncPlayCreateGroup(requestParameters.newGroupRequestDto, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Gets all SyncPlay groups.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SyncPlayApi
     */
    SyncPlayApi.prototype.syncPlayGetGroups = function (options) {
        var _this = this;
        return exports.SyncPlayApiFp(this.configuration).syncPlayGetGroups(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Join an existing SyncPlay group.
     * @param {SyncPlayApiSyncPlayJoinGroupRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SyncPlayApi
     */
    SyncPlayApi.prototype.syncPlayJoinGroup = function (requestParameters, options) {
        var _this = this;
        return exports.SyncPlayApiFp(this.configuration).syncPlayJoinGroup(requestParameters.joinGroupRequestDto, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Leave the joined SyncPlay group.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SyncPlayApi
     */
    SyncPlayApi.prototype.syncPlayLeaveGroup = function (options) {
        var _this = this;
        return exports.SyncPlayApiFp(this.configuration).syncPlayLeaveGroup(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Request to move an item in the playlist in SyncPlay group.
     * @param {SyncPlayApiSyncPlayMovePlaylistItemRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SyncPlayApi
     */
    SyncPlayApi.prototype.syncPlayMovePlaylistItem = function (requestParameters, options) {
        var _this = this;
        return exports.SyncPlayApiFp(this.configuration).syncPlayMovePlaylistItem(requestParameters.movePlaylistItemRequestDto, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Request next item in SyncPlay group.
     * @param {SyncPlayApiSyncPlayNextItemRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SyncPlayApi
     */
    SyncPlayApi.prototype.syncPlayNextItem = function (requestParameters, options) {
        var _this = this;
        return exports.SyncPlayApiFp(this.configuration).syncPlayNextItem(requestParameters.nextItemRequestDto, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Request pause in SyncPlay group.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SyncPlayApi
     */
    SyncPlayApi.prototype.syncPlayPause = function (options) {
        var _this = this;
        return exports.SyncPlayApiFp(this.configuration).syncPlayPause(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update session ping.
     * @param {SyncPlayApiSyncPlayPingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SyncPlayApi
     */
    SyncPlayApi.prototype.syncPlayPing = function (requestParameters, options) {
        var _this = this;
        return exports.SyncPlayApiFp(this.configuration).syncPlayPing(requestParameters.pingRequestDto, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Request previous item in SyncPlay group.
     * @param {SyncPlayApiSyncPlayPreviousItemRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SyncPlayApi
     */
    SyncPlayApi.prototype.syncPlayPreviousItem = function (requestParameters, options) {
        var _this = this;
        return exports.SyncPlayApiFp(this.configuration).syncPlayPreviousItem(requestParameters.previousItemRequestDto, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Request to queue items to the playlist of a SyncPlay group.
     * @param {SyncPlayApiSyncPlayQueueRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SyncPlayApi
     */
    SyncPlayApi.prototype.syncPlayQueue = function (requestParameters, options) {
        var _this = this;
        return exports.SyncPlayApiFp(this.configuration).syncPlayQueue(requestParameters.queueRequestDto, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Notify SyncPlay group that member is ready for playback.
     * @param {SyncPlayApiSyncPlayReadyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SyncPlayApi
     */
    SyncPlayApi.prototype.syncPlayReady = function (requestParameters, options) {
        var _this = this;
        return exports.SyncPlayApiFp(this.configuration).syncPlayReady(requestParameters.readyRequestDto, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Request to remove items from the playlist in SyncPlay group.
     * @param {SyncPlayApiSyncPlayRemoveFromPlaylistRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SyncPlayApi
     */
    SyncPlayApi.prototype.syncPlayRemoveFromPlaylist = function (requestParameters, options) {
        var _this = this;
        return exports.SyncPlayApiFp(this.configuration).syncPlayRemoveFromPlaylist(requestParameters.removeFromPlaylistRequestDto, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Request seek in SyncPlay group.
     * @param {SyncPlayApiSyncPlaySeekRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SyncPlayApi
     */
    SyncPlayApi.prototype.syncPlaySeek = function (requestParameters, options) {
        var _this = this;
        return exports.SyncPlayApiFp(this.configuration).syncPlaySeek(requestParameters.seekRequestDto, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Request SyncPlay group to ignore member during group-wait.
     * @param {SyncPlayApiSyncPlaySetIgnoreWaitRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SyncPlayApi
     */
    SyncPlayApi.prototype.syncPlaySetIgnoreWait = function (requestParameters, options) {
        var _this = this;
        return exports.SyncPlayApiFp(this.configuration).syncPlaySetIgnoreWait(requestParameters.ignoreWaitRequestDto, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Request to set new playlist in SyncPlay group.
     * @param {SyncPlayApiSyncPlaySetNewQueueRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SyncPlayApi
     */
    SyncPlayApi.prototype.syncPlaySetNewQueue = function (requestParameters, options) {
        var _this = this;
        return exports.SyncPlayApiFp(this.configuration).syncPlaySetNewQueue(requestParameters.playRequestDto, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Request to change playlist item in SyncPlay group.
     * @param {SyncPlayApiSyncPlaySetPlaylistItemRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SyncPlayApi
     */
    SyncPlayApi.prototype.syncPlaySetPlaylistItem = function (requestParameters, options) {
        var _this = this;
        return exports.SyncPlayApiFp(this.configuration).syncPlaySetPlaylistItem(requestParameters.setPlaylistItemRequestDto, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Request to set repeat mode in SyncPlay group.
     * @param {SyncPlayApiSyncPlaySetRepeatModeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SyncPlayApi
     */
    SyncPlayApi.prototype.syncPlaySetRepeatMode = function (requestParameters, options) {
        var _this = this;
        return exports.SyncPlayApiFp(this.configuration).syncPlaySetRepeatMode(requestParameters.setRepeatModeRequestDto, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Request to set shuffle mode in SyncPlay group.
     * @param {SyncPlayApiSyncPlaySetShuffleModeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SyncPlayApi
     */
    SyncPlayApi.prototype.syncPlaySetShuffleMode = function (requestParameters, options) {
        var _this = this;
        return exports.SyncPlayApiFp(this.configuration).syncPlaySetShuffleMode(requestParameters.setShuffleModeRequestDto, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Request stop in SyncPlay group.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SyncPlayApi
     */
    SyncPlayApi.prototype.syncPlayStop = function (options) {
        var _this = this;
        return exports.SyncPlayApiFp(this.configuration).syncPlayStop(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Request unpause in SyncPlay group.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SyncPlayApi
     */
    SyncPlayApi.prototype.syncPlayUnpause = function (options) {
        var _this = this;
        return exports.SyncPlayApiFp(this.configuration).syncPlayUnpause(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return SyncPlayApi;
}(base_1.BaseAPI));
exports.SyncPlayApi = SyncPlayApi;
